import React from 'react';
import ProviderService from '../../../services/provider';
import { filterData } from '../../../utils/function';
import { CODES } from '../../../utils/httpCodes';
import { simpleAlerts } from '../../../utils/alerts';

const columns = [
    { id: 'id_proveedor', label: '#', width: 25, align: 'center', },
    { id: 'documento', label: 'Documento', width: 80, align: 'center', },
    { id: 'nombre', label: 'Nombre', width: 200, align: 'left', },
    { id: 'telefono', label: 'Telefono', width: 100, align: 'center', },
    { id: 'email', label: 'Email', width: 100, align: 'center', },
    { id: 'estado_id', label: 'Estado', width: 80, align: 'center', },
    { id: 'actions', label: 'Acciones', width: 50, align: 'center', },
];

const columnsMap = {
    estado_id: 'estado.desEstado',
};

function getValueFromPath(obj, path) {
    const pathArray = path.split('.');
    let value = obj;
    for (const key of pathArray) {
        if (value === null || value === undefined) {
            return ''; // O algún valor por defecto
        }
        value = value[key];
    }
    return value;
}

const BodyProvider = ({ handleOpenLoad, handleCloseLoad, setTitleLoad, getProviders, data, search, viewProvider }) => {
    const url = window.location.pathname;
    let resultSearch = filterData(data, search, ['documento', 'nombre']);

    const saveProvider = async (body) => {
        handleOpenLoad();
        setTitleLoad('Desactivado ...');
        try {
            body.estado = 2;
            const result = await ProviderService.saveProviders(url, body);
            if (result.status === CODES.CREATE_201) {
                simpleAlerts(result?.data?.saveInfo?.message || 'Desactivado', 'success');
                getProviders();
            } else {
                simpleAlerts(result?.response?.data?.message || 'Error en el guardado', 'error');
                handleCloseLoad();
                setTitleLoad(null);
            }
            return [];
        } catch (error) {
            console.log(`Error en saveProviders: ${error}`);
        }
    }

    return (
        <div className='body-table table-responsive'>
            <div className="container">
                <div className="body-table-wrapper mt-3">
                    <table className="table table-bordered table-hover table-sm">
                        <thead className="table-dark sticky-top">
                            <tr>
                                {columns.map((col) => (
                                    <th
                                        scope="col"
                                        key={col.id}
                                        style={{
                                            textAlign: col.align,
                                            width: `${col.width}px`,
                                            maxWidth: `${col.width}px`
                                        }}
                                    >
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {resultSearch?.map((row, idx) => {
                                return (
                                    <tr key={idx}>
                                        {columns.map((col) => {
                                            const value = col.id in columnsMap ? getValueFromPath(row, columnsMap[col.id]) : row[col.id];
                                            return (
                                                <td
                                                    key={col.id}
                                                    style={{
                                                        textAlign: col.align,
                                                        width: `${col.width}px`,
                                                        maxWidth: `${col.width}px`,
                                                        overflowX: 'scroll',
                                                    }}
                                                >
                                                    {col.id === 'actions' ?
                                                        <>
                                                            <button type="button" className="btn btn-outline-dark btn-sm mr-1 buttons-grid" onClick={() => viewProvider(row)}>
                                                                <i className="fa-solid fa-pen-to-square"></i>
                                                            </button>
                                                            <button type="button" className="btn btn-outline-danger btn-sm mr-1 buttons-grid" onClick={() => saveProvider(row)}>
                                                                <i className="fa-solid fa-trash"></i>
                                                            </button>
                                                        </>
                                                        : (col.type === 'number' && col.format) ? col.format(value) : value
                                                    }

                                                </td>

                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default BodyProvider